import React, { useState, useEffect } from "react";
import { Card, Table, Modal, Col, Row, Button } from "react-bootstrap";
import * as Builders from '../../Builders';

function LiveVisualizer(props) {
    const { data, changeQuestion } = props;
    const [question, setQuestion] = useState(null);

    useEffect(() => {
        if (data.selected) {
            setQuestion(data.selected);
        }
    }, [data.selected])

    const onPrev = () => {
        if (data.selectedIndex !== 0) {
            let index = data.selectedIndex - 1;
            changeQuestion(data.questions[index].question, index);
        }
    }

    const onNext = () => {
        if (data.selectedIndex !== data.questions.length - 1) {
            let index = data.selectedIndex + 1;
            changeQuestion(data.questions[index].question, index);
        }
    }

    const renderQuestion = (question) => {
        const qProps = { question };
        return <Builders.Questions.Visualizer {...qProps} />
    }

    return (
        <div>
            <Row style={{ alignSelf: 'center', alignItems: 'center', width: '100%', marginTop: "10px" }}>
                <Col xs={4} className="text-center">
                    {data.selectedIndex !== 0 && (
                        <Button onClick={onPrev} variant="secondary" size="sm" className="rounded-pill">PREV</Button>
                    )}
                </Col>
                <Col xs={4} className="text-center">Question {data.selectedIndex + 1} of {data.questions.length}</Col>
                <Col xs={4} className="text-center">
                    {data.selectedIndex !== data.questions.length - 1 && (
                        <Button onClick={onNext} variant="secondary" size="sm" className="rounded-pill">NEXT</Button>
                    )}
                </Col>
            </Row>

            {question && (<>
                <Row className="text-center mt-3">
                    <Col xs={12}>
                        <h6>{question.instructions}</h6>
                        <h6>{question.label}</h6>
                    </Col>
                </Row>
                <Row className="mt-3" >
                    <Col xs={12} >
                        {renderQuestion(question)}
                    </Col>
                </Row>
            </>)}
        </div>
    )
}

export default LiveVisualizer;